export default {
  en: {
    jumbotron: {
      index: {
        welcome: 'Learn talking to ATC',
        intro: 'Train with real procedures, official test questions and improve your skills in the simulator.',
        imageAlt: 'Cessna Caravan animated to simulate takeoff and landing',
        trynow: 'Try now for free',
        features: 'Features',
        convincer1: 'Better prepared - with fewer flight hours',
        convincer2: 'No download required',
        convincer3: 'Cancel anytime',
        convincer4: 'For beginners and advanced users',
      }
    }
  },
  de: {
    jumbotron: {
      index: {
        welcome: 'Lerne mit dem ATC zu sprechen',
        intro: 'Trainiere mit echten Verfahren, offiziellen Testfragen und verbessere deine Fähigkeiten im Simulator.',
        imageAlt: 'Cessna Caravan animiert, um Start und Landung zu simulieren',
        trynow: 'Jetzt kostenlos testen',
        features: 'Funktionen',
        convincer1: 'Besser vorbereitet - mit weniger Flugstunden',
        convincer2: 'Kein Download erforderlich',
        convincer3: 'Jederzeit kündbar',
        convincer4: 'Für Anfänger und Fortgeschrittene',
      }
    }
  },
  es: {
    jumbotron: {
      index: {
        welcome: 'Aprende a hablar con ATC',
        intro: 'Entrena con procedimientos reales, preguntas de examen oficiales y mejora tus habilidades en el simulador.',
        imageAlt: 'Cessna Caravan animada para simular despegue y aterrizaje',
        trynow: 'Pruébalo gratis ahora',
        features: 'Características',
        convincer1: 'Mejor preparado - con menos horas de vuelo',
        convincer2: 'No se requiere descarga',
        convincer3: 'Cancela en cualquier momento',
        convincer4: 'Para principiantes y usuarios avanzados',
      }
    }
  },
  uk: {
    jumbotron: {
      index: {
        welcome: 'Навчіться розмовляти з ATC',
        intro: 'Тренуйтеся з реальними процедурами, офіційними тестовими запитаннями та покращуйте свої навички в симуляторі.',
        imageAlt: 'Cessna Caravan анімована для моделювання зльоту та посадки',
        trynow: 'Спробуйте зараз безкоштовно',
        features: 'Особливості',
        convincer1: 'Краще підготовлені - з меншою кількістю годин польоту',
        convincer2: 'Завантаження не потрібно',
        convincer3: 'Скасувати в будь-який час',
        convincer4: 'Для початківців та досвідчених користувачів',
      }
    }
  }
}
